import { render, staticRenderFns } from "./StripePayment.vue?vue&type=template&id=52f3fca7&scoped=true&lang=pug"
import script from "./StripePayment.vue?vue&type=script&lang=ts"
export * from "./StripePayment.vue?vue&type=script&lang=ts"
import style0 from "./StripePayment.vue?vue&type=style&index=0&id=52f3fca7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f3fca7",
  null
  
)

export default component.exports